/**
 * Application Constants
 * Define all constant values used across the application
 */

export const CONFIG = {
    // Chrome Web Store URL
    CHROME_STORE_URL: 'https://chromewebstore.google.com/detail/zengpt-chatgpt-auto-organ/lcbjipcdbfpgdmbehigpdmbbknnjkfak',

    // Extension Info
    EXTENSION_NAME: 'zenGPT',
    VERSION: '1.0.4',

    // Contact
    SUPPORT_EMAIL: 'support@zengpt.com',
    PRIVACY_EMAIL: 'privacy@zengpt.com',

    // Social Links (add when available)
    GITHUB_URL: '',
    DISCORD_URL: '',
    TWITTER_URL: '',

    // Animation Settings
    ANIMATION: {
        SCROLL_OFFSET: 50,
        FADE_DURATION: 800,
        STAGGER_DELAY: 150
    },

    // Navbar Settings
    NAVBAR: {
        SCROLL_THRESHOLD: 50,
        BLUR_AMOUNT: '12px'
    }
};

export const SELECTORS = {
    // Main elements
    NAVBAR: '.navbar',
    LOGO: '.logo',
    NAV_LINKS: '.nav-links a',

    // Buttons
    CTA_PRIMARY: '.cta-button.primary',
    CTA_SECONDARY: '.cta-button.secondary',

    // FAQ
    FAQ_ITEMS: '.faq-item',
    FAQ_QUESTION: '.faq-question',

    // Features
    FEATURE_BLOCKS: '.feature-block',

    // Sections
    DEMO_SECTION: '#demo',
    FEATURES_SECTION: '#features',
    FAQ_SECTION: '#faq'
};

export const CLASSES = {
    ACTIVE: 'active',
    HIDDEN: 'hidden',
    VISIBLE: 'visible',
    ANIMATE_FADE_IN: 'animate-fade-in',
    ANIMATE_FADE_IN_UP: 'animate-fade-in-up'
};
